import Repository from "./repository"

export default {
    /**
     * アクセス権限確認のためのコントローラ呼び出し
     */
    view() {
        return Repository.get('/api/s206-number-of-user-changes/view')
    },

    add(params) {
        return Repository.post('/api/s206-number-of-user-changes/add', params)
    }
}